import { supabase } from '../supabaseClient';

export const clientsService = {
    async getAll() {
        const { data, error } = await supabase
            .from('agent_clients')
            .select('*')
            .order('created_at', { ascending: false });
        if (error) throw error;
        return data;
    },

    async getCount() {
        const { count, error } = await supabase
            .from('agent_clients')
            .select('*', { count: 'exact', head: true });
        if (error) throw error;
        return count;
    },

    async getStats() {
        const { data, error } = await supabase
            .from('agent_clients')
            .select('carrier, status, effective_date');
        if (error) throw error;

        const stats = {
            totalClients: data.length,
            activeClients: data.filter(c => c.status === 'active' || c.status === 'activo').length,
            carriers: {},
            recentClients: data.filter(c => {
                if (!c.effective_date) return false;
                const effectiveDate = new Date(c.effective_date);
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                return effectiveDate >= thirtyDaysAgo;
            }).length
        };

        data.forEach(client => {
            if (client.carrier) {
                stats.carriers[client.carrier] = (stats.carriers[client.carrier] || 0) + 1;
            }
        });

        return stats;
    },

    async search(query) {
        const { data, error } = await supabase
            .from('agent_clients')
            .select('*')
            .or(`name.ilike.%${query}%,email.ilike.%${query}%,policy_number.ilike.%${query}%`)
            .order('created_at', { ascending: false });
        if (error) throw error;
        return data;
    },

    async upsertBatch(clients, onProgress) {
        const results = { success: 0, errors: [] };
        const batchSize = 50;

        for (let i = 0; i < clients.length; i += batchSize) {
            const batch = clients.slice(i, i + batchSize);
            // IMPORTANTE: ignoreDuplicates: true para NO sobrescribir datos existentes
            const { data, error } = await supabase
                .from('agent_clients')
                .upsert(batch, { onConflict: 'policy_number,agent_npn', ignoreDuplicates: true })
                .select();

            if (error) {
                results.errors.push({ batch: i / batchSize, error: error.message });
            } else {
                results.success += data?.length || 0;
            }

            if (onProgress) {
                const progress = Math.min(100, Math.round(((i + batch.length) / clients.length) * 100));
                onProgress(progress);
            }
        }

        return results;
    },

    async delete(id) {
        const { error } = await supabase.from('agent_clients').delete().eq('id', id);
        if (error) throw error;
    }
};
